import { v4 as uuidv4 } from 'uuid'

/**
 * Generate unique node ID
 */
export const generateNodeId = (): string => {
  const id = uuidv4()
  return id
}

/**
 * Generate unique edge ID from source and target node IDs
 * Uses UUID to ensure uniqueness even for duplicate connections
 */
export const generateEdgeId = (sourceId: string, targetId: string): string => {
  const baseId = `e${sourceId}-${targetId}`
  const uniqueSuffix = uuidv4().substring(0, 8)
  const edgeId = `${baseId}-${uniqueSuffix}`
  return edgeId
}
